/**
 * Skeleton — a shimmering placeholder block for loading states. Size it with
 * `width` / `height` (any CSS length) and choose a `radius`. Defaults to a
 * single text-line shaped bar.
 */
import { forwardRef, type CSSProperties, type HTMLAttributes } from "react";

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  /** CSS width. @default "100%" */
  readonly width?: number | string;
  /** CSS height. @default "1em" */
  readonly height?: number | string;
  /** Corner style. @default "2" */
  readonly radius?: "1" | "2" | "3" | "4" | "pill";
}

export const Skeleton = forwardRef<HTMLSpanElement, SkeletonProps>(function Skeleton(
  { width = "100%", height = "1em", radius = "2", className, style, ...rest },
  ref,
) {
  const merged: CSSProperties = {
    width,
    height,
    borderRadius: `var(--r-${radius})`,
    ...style,
  };
  return (
    <span
      ref={ref}
      aria-hidden="true"
      className={["lc-skeleton", className].filter(Boolean).join(" ")}
      style={merged}
      {...rest}
    />
  );
});
